import axios from "axios";

let urls = process.env.urls;

// console.log("Env value for urls " + urls);

// STORE THIS IN ENV FILE
//urls = "https://billing-test.services.orcicare.com/"

//const api_port = "5001";

const get_urls = () => {
  // console.log("Running in local", process.env);
  const host = window.location.host.split(":")[0];
  if (host === "billing-web.services.orcicare.com") {
    return "https://billing.services.orcicare.com/";
  }
  if (host === "billing-web-test.services.orcicare.com") {
    return "https://billing-test.services.orcicare.com/";
  }
  if (host === "billing-web-demo.services.orcicare.com") {
    return "https://billing-demo.services.orcicare.com/";
  }
  return "https://billing-test.services.orcicare.com/";
  //return "https://192.168.0.106:5000/"; // default port vs code
  //return `https://${[host, api_port].join(":")}/`; // for aws cloud9
};
const url = urls || get_urls();

const instance = axios.create({
  baseURL: url,
});

export default instance;
